export default __webpack_public_path__ + "static/media/a024-11.d66274cd.svg";